import React from 'react';
import { ReactEditor, useReadOnly } from 'slate-react';
import { AulaPlugin } from '../plugins';
import { BlockMenu } from '../../components/BlockMenu/BlockMenu';
import { BlockContent, BlockMenuWrapper } from './blockMenu.styled';

export const blockMenu: AulaPlugin = (editableProps, editor, context) => ({
  ...editableProps,
  renderElement: (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isReadOnly = useReadOnly();

    if (context == null) {
      throw new Error('context methods must be defined');
    }

    if (editableProps.renderElement == null) {
      throw new Error('blockMenu plugin cannot be first renderElement method');
    }

    const { element } = props;

    const path = ReactEditor.findPath(editor, element);
    const content = editableProps.renderElement(props);

    if (path.length > 1 || isReadOnly) {
      return content;
    }
    return (
      <BlockMenuWrapper>
        {
          /**
           * Plugin Order Matters.
           *
           * We only want to display blockMenu when it has actually
           * been composed by the plugins ahead of this plugin.
           */
          editableProps.blockMenu != null && (
            <BlockMenu
              context={context}
              element={element}
              renderSubMenuItem={editableProps.renderSubMenuItem}
              blockMenu={editableProps.blockMenu}
            />
          )
        }
        <BlockContent>{content}</BlockContent>
      </BlockMenuWrapper>
    );
  },
});
